import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AssessorAssignments, AssessorAssignmentsValue, LookupOption } from '../models';

export const assessorAssignmentsActions = createActionGroup({
    source: 'Assessor Assignments',
    events: {
        'Get Assignments': props<{ userId: string }>(),
        'Get Assignments Success': props<{ payload: AssessorAssignments }>(),
        'Get Assignments Error': props<{ code: number }>(),

        'Update Assignments': props<{ userId: string; value: AssessorAssignmentsValue }>(),
        'Update Assignments Success': props<{ payload: AssessorAssignments }>(),
        'Update Assignments Error': props<{ code: number }>(),

        'Get Schools': props<{ organisationIds: string[] }>(),
        'Get Schools Success': props<{ payload: LookupOption[] }>(),
        'Get Schools Error': props<{ code: number }>(),

        'Get Courses': props<{ schoolIds: string[] }>(),
        'Get Courses Success': props<{ payload: LookupOption[] }>(),
        'Get Courses Error': props<{ code: number }>(),

        'Get Packages': props<{ schoolIds: string[] }>(),
        'Get Packages Success': props<{ payload: LookupOption[] }>(),
        'Get Packages Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
